import React from 'react'
import {numVal} from '../../../modules/Utils'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'
import {round, sum} from 'lodash'

function SumFooter({data, column}) {
  return (
    <strong>
      {MoneyCell({
        value: round(sum(data.map(d => numVal(d, column.id))), 2),
      })}
    </strong>
  )
}

export default SumFooter
